import { downloadFromUrl } from '@/lib/download';
import { Download } from 'lucide-react';

import { type IFileElement } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';

import { FileCardContent } from './FileCardContent';

const FileElement = ({ element }: { element: IFileElement }) => {
    if (!element.url) {
        return null;
    }

    // Clicking the card opens the right sidebar's Uploaded/Embedded Files
    // panel. Only the Download button below actually downloads the file.
    const handleOpenUploadsPanel = () => {
        window.dispatchEvent(
            new CustomEvent('openUploadsSidebar', {
                detail: { elementId: element.id }
            })
        );
    };

    const handleDownload = (event: React.MouseEvent) => {
        // Stop this from also bubbling to the card's own onClick above.
        event.stopPropagation();
        downloadFromUrl(element.url!, element.name);
    };

    return (
        <div
            className={`${element.display}-file flex items-center gap-3 bg-card/25 hover:bg-muted/50 p-4 justify-between border border-border rounded-lg w-full transition-colors cursor-pointer`}
            onClick={handleOpenUploadsPanel}
        >
            <FileCardContent name={element.name} />

            <Button
                variant="tertiary"
                size="default"
                onClick={handleDownload}
                className="bg-background text-sm"
            >
                <Download />
                Download
            </Button>
        </div>
    );
};

export { FileElement };
